import Remark from './Remark';

export default Remark;
